import {Component, ElementRef, EventEmitter, Input, Output} from '@angular/core';

@Component({
    selector: 'canal-text',
    template: `
        <span *ngFor="let text of canalTexts"
              (click)="!text.Type || _emitClick(text)"
              (press)="!text.Type || _emitPress(text)"
              [ngClass]="{
                  'font-bold': text.Bold > 0, 
                  'text-decoration-underline': text.Bold == 2, 
                  'cursor-pointer': text.Type
              }"
              [ngStyle]="{color: text.Tint}">
            {{ text.Text }}
        </span>
    `
})

export class CanalText {

    @Input('canal-texts') canalTexts: Array<any> = [];

    @Output('canal-click') private _click: EventEmitter<any> = new EventEmitter();
    @Output('canal-press') private _press: EventEmitter<any> = new EventEmitter();

    constructor(public element:ElementRef) {

        this.canalTexts = this.canalTexts || [];

    }

    _emitClick(item) {

        this._click.emit(item);

    }

    _emitPress(item) {

        this._press.emit(item);

    }

}



// WEBPACK FOOTER //
// ./src/components/canal-text/canal-text.ts